import React from "react";
import classNames from "classnames";
import { CardFooter } from "./card-footer";
import { CardHeader } from "./card-header";

interface CardProps {
    className?: string;
    header?: string;
    footer?: string;
    shadow?: number;
    outline?: boolean;
    [x: string]: any;
}

/**
 * **Cards** contain content and actions about a single subject
 *
 * They should be easy to scan for relevant and actionable information.
 * Elements, like text and images, should be placed on them in a way that clearly indicates hierarchy.
 */
export const Card = ({ className, header, footer, shadow, outline, ...props }: CardProps) => {
    if (outline === true) shadow = 0;
    var cn = classNames("card", className, shadow, {
        ["shadow-" + shadow]: shadow >= 0 && shadow <= 24,
        "border-0": !outline,
    });
    return (
        <div className={cn} {...props}>
            {!!header && <CardHeader>{header}</CardHeader>}
            {props.children}
            {!!footer && <CardFooter>{footer}</CardFooter>}
        </div>
    );
};
